"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { LinkPreviewCardLayout } from "@/components/waves/OpenGraphPreview";
import { fetchLinkPreview } from "@/services/api/link-preview-api";
import EnsPreviewCard from "./EnsPreviewCard";
import { isEnsPreview, type EnsPreview } from "./types";
interface EnsLinkPreviewProps {
  readonly href: string;
}
type PreviewState = {
  readonly type: "loading";
} | {
  readonly type: "success";
  readonly data: EnsPreview;
} | {
  readonly type: "error";
  readonly error: Error;
};
export default function EnsLinkPreview(t0) {
  const $ = _c(12);
  const {
    href
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      type: "loading"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [state, setState] = useState(t1);
  let t2;
  let t3;
  if ($[1] !== href) {
    t2 = () => {
      let active = true;
      setState({
        type: "loading"
      });
      fetchLinkPreview(href).then(response => {
        if (!active) {
          return;
        }
        if (isEnsPreview(response)) {
          setState({
            type: "success",
            data: response
          });
          return;
        }
        setState({
          type: "error",
          error: new Error("ENS preview unavailable")
        });
      }).catch(error => {
        if (!active) {
          return;
        }
        setState({
          type: "error",
          error: error instanceof Error ? error : new Error("Failed to load ENS preview")
        });
      });
      return () => {
        active = false;
      };
    };
    t3 = [href];
    $[1] = href;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  if (state.type === "error") {
    throw state.error;
  }
  if (state.type === "success") {
    let t4;
    if ($[4] !== state.data) {
      t4 = <div className="tw-rounded-xl tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900/40 tw-p-4"><EnsPreviewCard preview={state.data} /></div>;
      $[4] = state.data;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== href || $[7] !== t4) {
      t5 = <LinkPreviewCardLayout href={href}>{t4}</LinkPreviewCardLayout>;
      $[6] = href;
      $[7] = t4;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    return t5;
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="tw-animate-pulse tw-rounded-xl tw-border tw-border-solid tw-border-iron-700 tw-bg-iron-900/40 tw-p-4" data-testid="ens-preview-loading"><div className="tw-flex tw-flex-col tw-gap-y-3"><div className="tw-h-6 tw-w-1/3 tw-rounded tw-bg-iron-800/60" /><div className="tw-h-4 tw-w-2/3 tw-rounded tw-bg-iron-800/40" /><div className="tw-h-3 tw-w-full tw-rounded tw-bg-iron-800/30" /></div></div>;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== href) {
    t5 = <LinkPreviewCardLayout href={href}>{t4}</LinkPreviewCardLayout>;
    $[10] = href;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}